export default __webpack_public_path__ + "static/media/SudhaJadhav.dc7780a9.png";